export default __webpack_public_path__ + "static/media/greater-dubai.6d8b4c39.webp";